import axios from "axios";
import { encodeBody, encodeQueryParams } from "./client";
import { baseUrl } from "./config";

export const getEvaluationReport: any = (params: any) => {
    const path = `${baseUrl}/api/reports${encodeQueryParams(params)}`;
    return axios({
        method: 'GET',
        url: path,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }).then(response => response.data.data).catch((err) => console.error('Error in getEvaluationReport:', err));
};

export const getEvaluationReportList: any = (params: any) => {
    const path = `${baseUrl}/api/reports/club/${params.clubId}`;
    return axios({
        method: 'GET',
        url: path,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }).then(response => response.data.data).catch((err) => console.error('Error in getEvaluationReportList:', err));
};

export const getEvaluationReportFolders: any = (params: any) => {
    const path = `${baseUrl}/api/reports/folders/${params.clubId}`;
    return axios({
        method: 'GET',
        url: path,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }).then(response => response.data).catch((err) => console.error('Error in getEvaluationReportFolders:', err));
};

export const saveExecutiveSummary: any = (params:any) => {
  const path = `${baseUrl}/api/reports/executiveSummary`;
  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(params),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};